import { render, staticRenderFns } from "./kit.vue?vue&type=template&id=9ec0fae2&scoped=true"
import script from "./kit.vue?vue&type=script&lang=js"
export * from "./kit.vue?vue&type=script&lang=js"
import style0 from "./kit.vue?vue&type=style&index=0&id=9ec0fae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec0fae2",
  null
  
)

export default component.exports